import request from '@/utils/request'

/**
 * 获取我的工作空间列表
 * @param {Object} params - 查询参数
 * @param {number} params.current - 当前页码，默认1
 * @param {number} params.size - 每页数量，默认10
 * @returns {Promise}
 */
export function getMyWorkspaces(params = {}) {
  return request({
    url: '/api/workspace/my',
    method: 'get',
    params: {
      current: params.current || 1,
      size: params.size || 10,
      // 可选：按剧本过滤工作空间
      scriptId: params.scriptId
    }
  })
}

/**
 * 新建工作空间
 * @param {Object} data
 * @param {string} data.name
 * @param {string} [data.description]
 * @returns {Promise}
 */
export function createWorkspace(data) {
  return request({
    url: '/api/workspace',
    method: 'post',
    data
  })
}

/**
 * 更新工作空间
 * @param {number|string} id - 工作空间ID
 * @param {Object} data - 更新数据
 * @returns {Promise}
 */
export function updateWorkspace(id, data) {
  return request({
    url: `/api/workspace/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除工作空间
 * @param {number|string} id - 工作空间ID
 * @returns {Promise}
 */
export function deleteWorkspace(id) {
  return request({
    url: `/api/workspace/${id}`,
    method: 'delete'
  })
}

